var styleDataHash = "1e811c8c";
const injectCss = () => {
  var css = `.MQ9Rj{margin-left:0;margin-right:auto;z-index:1}.MQ9Rj:not(.ti4Wq){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.MQ9Rj:not(.ti4Wq){float:none;margin-right:auto}}}@container (width < 640px){.MQ9Rj:not(.ti4Wq){float:none;margin-right:auto}}.ZwKNJ{margin-left:auto;margin-right:0;z-index:1}.ZwKNJ:not(.ti4Wq){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.ZwKNJ:not(.ti4Wq){float:none;margin-left:auto}}}@container (width < 640px){.ZwKNJ:not(.ti4Wq){float:none;margin-left:auto}}.MkFw5{clear:both;display:block}.MkFw5:not(.qMKfr){margin-left:auto;margin-right:auto;max-width:100%}.qMKfr,.ti4Wq{width:100%}.QDi2I .qMKfr,.QDi2I .ti4Wq{margin:0 -8px;width:auto}._3xFzr{width:fit-content}.RZHMY{margin-left:auto;margin-right:auto;max-width:100%}.LsOOW{width:min(350px,100%)!important}.QDi2I .LsOOW{width:50%}.jdDsd{margin-left:auto;margin-right:auto}.QDi2I .jdDsd{width:150px}._2k1v-{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_rtlignore_default = {
  "alignLeft": "MQ9Rj",
  "textWrapNowrap": "ti4Wq",
  "alignRight": "ZwKNJ",
  "alignCenter": "MkFw5",
  "sizeFullWidth": "qMKfr",
  "renderedInTable": "QDi2I",
  "sizeOriginal": "_3xFzr",
  "sizeContent": "RZHMY",
  "sizeSmall": "LsOOW",
  "sizeSmallCenter": "jdDsd",
  "flex": "_2k1v-"
};
export {
  general_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=general.rtlignore-scss.js.map
